export const defaultPaginationObject = () => ({
  items: [],
  itemCount: 0,
  page: 1,
  pageCount: 1,
})

export type PaginationParams<T> = {
  page: number
  itemsPerPage: number
} & T

export type PaginationResponse<T> = {
  page: number
  pageCount: number
  itemCount: number
  items: T[]
}

const MAX_ITEMS_PER_PAGE = 100

export async function getAllPages<
  T extends PaginationResponse<T['items'][number]>,
  D,
>(
  paginatedFetcher: (params: PaginationParams<D>) => Promise<T>,
  params: D
): Promise<T> {
  const promises = []
  const firstPagePromise = paginatedFetcher({
    ...params,
    page: 1,
    itemsPerPage: MAX_ITEMS_PER_PAGE,
  })
  promises.push(firstPagePromise)
  const firstPage = await firstPagePromise

  if (firstPage.pageCount && firstPage.pageCount > 1) {
    for (let i = 2; i <= firstPage.pageCount; i++) {
      const promise = paginatedFetcher({
        ...params,
        page: i,
        itemsPerPage: MAX_ITEMS_PER_PAGE,
      })
      promises.push(promise)
    }
  }

  const pages = await Promise.all(promises)
  return {
    page: Infinity,
    pageCount: Infinity,
    itemCount: firstPage.itemCount,
    items: pages.flatMap((page) => page.items),
  } as T
}
